import moment from 'moment'
import {RedirectInvalidUser } from "../service/authServices";
import { ShowMessage } from '../components/UI/showMessage/ShowMessage';

export function formatDateMoment (stringDate, formatMoment, formatFinal){
    const date = moment(stringDate, formatMoment);
    return date.isValid()? date.format(formatFinal): "";
}

export function formatPorcentage (value){
    return value.toString().replace(".", ",");
}

const numberFormatterDecimal = (c,i,a)=> i && c!=="." && (a.length - i) %3 === 0 ?  `.${c}` : c;

export const formatNumberDecimal= number => number.toString().replace(/./g, numberFormatterDecimal);

export const StrParams = (msg, params)=>{
    params.forEach((element, index) => {
        msg = String(msg).replace(`{${index}}`, element);
    });
    return msg;
} 

export const StrParamsShowMsg = (msg, params)=>{
    params.forEach((element, index) => {
        msg = String(msg).replace(`((${index}))`, element);
    });
    return msg;  
}

export const CalcDv = (nit, pais) =>{

    if ( pais === "CO" ) {
        let arreglo;
        let x;
        let y;
        let z;
        let i;
        let dv1;
        const nit1 = nit?.value ? nit.value : nit;
        if( nit1 !== "" ) {
            if(isNaN(nit1)){
                document.getElementById("dv").value="0";
            }else{
                arreglo=new Array(16);
                x=0;y=0;z=nit1.length;arreglo[1]=3;arreglo[2]=7;arreglo[3]=13;arreglo[4]=17;
                arreglo[5]=19;arreglo[6]=23;arreglo[7]=29;arreglo[8]=37;arreglo[9]=41;arreglo[10]=43;
                arreglo[11]=47;arreglo[12]=53;arreglo[13]=59;arreglo[14]=67;arreglo[15]=71;
                for(i=0;i<z;i++){
                    y=(nit1.substr(i,1));x+=(y*arreglo[z-i]);
                }
                y=x%11
                if(y>1){
                    dv1=11-y;
                }else{
                    dv1=y;
                }
                document.getElementById("dv").value=dv1;
            }
        }
    
    }
}

export const isInViewport = (id)  => {
    const el = document.getElementById(id);
    if(el){
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    
        );
    }
    return true;
}

export const ShowMessageTknExp = (app, user)=>{
    
    const idioma = user.idioma || sessionStorage.getItem("idioma") || 'es';
    var title;
    var message;
    var confirmButtonText;

    switch (idioma) {

        case "es":
            title = "Advertencia";
            message = "Su sesión ha caducado, Usted debe iniciar sesion nuevamente";
            confirmButtonText = "Aceptar";
        break;

        case "en":
            title = "Warning";
            message = "Your session has expired, you must login again";
            confirmButtonText = "Accept";
        break;

        case "pt":
            title = "Aviso";
            message = "A sua sessão expirou, é necessário iniciar novamente";
            confirmButtonText = "Aceitar";
        break;

        default:
            title = "Advertencia";
            message = "Su sesión ha caducado, Usted debe iniciar sesion nuevamente";
            confirmButtonText = "Aceptar";
        break;
    }

    ShowMessage(
        {
            title: title,
            message: message,
            typeMessage: "warning",
            showCancelButton: false,
            confirmButtonText: confirmButtonText,
            callbackConfirm: () => {
                RedirectInvalidUser(app);
            },
        }
    );


}